import { CalendarDays } from '@tamagui/lucide-icons';
import { Image } from '@unistocks/components/basic/image';
import { NativePressable } from '@unistocks/components/basic/pressable';
import { Card } from '@unistocks/components/layout/card';
import { Column, Row } from '@unistocks/components/layout/flex';
import { H4, Heading, Paragraph } from '@unistocks/components/text/text';
import {
  CalendarLayout,
  calendarLayoutOptions
} from '@unistocks/features/dashboard/components/dashboard-data/date/layout';
import { ValueListItem } from '@unistocks/features/dashboard/components/value-list-item/value-list-item';
import { FLAGS } from '@unistocks/features/portfolios/flags';
import { formatDate, t } from '@unistocks/shared/localization/index.ts';
import { today } from '@unistocks/shared/utils/util';
import { SelectProps } from '@unistocks/types/select-props';
import { CardHeader, Separator, YGroup } from 'tamagui';

export const CalendarLayoutSelect: React.FC<SelectProps<CalendarLayout>> = ({
  value,
  onChange
}) => (
  <Column gap={'$3'} mb={'$3'}>
    {calendarLayoutOptions.map(option => (
      <NativePressable key={option.value} onPress={() => onChange(option.value)}>
        <Card
          bordered
          elevate
          bg={value === option.value ? '$color4' : 'transparent'}
          $platform-web={{ cursor: 'pointer' }}
        >
          {option.value === CalendarLayout.Date ? (
            <DateLayoutPreview />
          ) : option.value === CalendarLayout.Events ? (
            <EventsLayoutPreview />
          ) : null}
        </Card>
      </NativePressable>
    ))}
  </Column>
);

const DateLayoutPreview = () => (
  <Row alignItems="center" justifyContent="center" gap={'$3'} padding={'$true'}>
    <CalendarDays size={'$4'} color={'$headingFont'} />
    <Column alignItems="center">
      <H4 userSelect="none">January 1</H4>
      <Paragraph userSelect="none">2025 | Week 1</Paragraph>
    </Column>
  </Row>
);

const EventsLayoutPreview = () => (
  <>
    <CardHeader mb={0}>
      <Heading>{t('::CalendarEvents:UpcomingEvents')}</Heading>
    </CardHeader>
    <YGroup padding={'$true'} pt={0}>
      <YGroup.Item>
        <H4 color={'$headingFont'}>{formatDate(today())}</H4>
      </YGroup.Item>
      <YGroup.Item>
        <ValueListItem
          title="Example Asset"
          subTitle="Dividend"
          bg={'transparent'}
          hoverStyle={{
            bg: 'transparent'
          }}
          pressStyle={{
            bg: 'transparent'
          }}
          icon={<Image rounded size={'$2'} source={FLAGS.us_market} />}
        />
      </YGroup.Item>
      <Separator />
      <YGroup.Item>
        <ValueListItem
          title="Example Asset"
          subTitle="Earnings date"
          bg={'transparent'}
          hoverStyle={{
            bg: 'transparent'
          }}
          pressStyle={{
            bg: 'transparent'
          }}
          icon={<Image rounded size={'$2'} source={FLAGS.us_market} />}
        />
      </YGroup.Item>
    </YGroup>
  </>
);

CalendarLayoutSelect.displayName = 'CalendarLayoutSelect';
